import { render, staticRenderFns } from "./category_list.vue?vue&type=template&id=649093e6&scoped=true"
import script from "./category_list.vue?vue&type=script&lang=js"
export * from "./category_list.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "649093e6",
  null
  
)

export default component.exports